import React, { useEffect, useState } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import logo from "../../assets/img/logo_menu_black.png";

import { ADMISION } from './Styles/StylesAdmision';

const Documentos = (props) => {

    const styles = StyleSheet.create(ADMISION[0]);

    let hoja = (img, est, doc) => {
        if (img === "") return null;

        return (
            <Page size="A4" style={styles.body}>
                <View style={[styles.row]}>
                    <View style={[styles.col11]}>
                        <Image style={styles.logoPq} src={logo} />
                    </View>
                    <View style={[styles.col12]}>
                        <Text style={[styles.encabezado3, {color: "#c60000"}]}>{est}</Text>
                        <Text style={[styles.encabezado3]}>{doc.toUpperCase()}</Text>
                    </View>
                </View>
                <View style = {[styles.bordeConstancia]}>
                    <Image src={img} />
                </View>
            </Page>
        )
    }

    let nombre = () => {
        let nom1 = "";
        let nom2 = "";
        let ape1 = "";
        let ape2 = "";
        let ci = "";

        if (props.nombre1 !== null) nom1 = props.nombre1;
        if (props.nombre2 !== null) nom2 = props.nombre2;
        if (props.apellido1 !== null) ape1 = props.apellido1;
        if (props.apellido2 !== null) ape2 = props.apellido2;
        if (props.ci !== null) ci = props.ci;

        return `${props.nac}${ci} - ${nom1} ${nom2} ${ape1} ${ape2}`;
    }
    

    return (
        
            <Document title="Planilla de Admisión">
                {hoja(props.file1, nombre(), "Copia de la Cédula de Identidad vigente")}
                {hoja(props.file2, "EJEMPLO", "Copia de la partida de nacimiento legible, sin tachadura ni enmienda, formato actual y vigente")}
                {hoja(props.file3, "EJEMPLO", "Copia de las notas certificadas de 1ero a 3er año de Educación Media")}
                {hoja(props.file4, "EJEMPLO", "Copia de las notas certificadas de 4ero a 5er año de Educación Media")}
            </Document>
        
    )
}

export default Documentos;


// WEBPACK FOOTER //
// ./src/components/Reportes/Documentos.jsx